import { Input, HStack, Button } from "@wootingkb/component-library";
import {
  EMAIL_LABEL,
  PASSWORD_LABEL,
} from "../../../utils/constants/i18n-strings";
import { msg } from "@lingui/core/macro";
import { useState, useCallback, FormEvent } from "react";
import { useSignin } from "../../../utils/hooks/useSignIn";
import { useLingui } from "@lingui/react";
import NextLink from "next/link";
import { LoginMethodProps } from "./types";

const CREATE_ACCOUNT_LINK = msg({
  id: "Auth_create_account_link",
  message: "Create an account",
});
const FORGOT_PASSWORD_LINK = msg({
  id: "Auth_forgot_password_link",
  message: "Forgot Password?",
});
const LOGIN_BUTTON = msg({ id: "Auth_login_button", message: "Login" });

export default function EmailPasswordLogin({ setLoading }: LoginMethodProps) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { signIn } = useSignin(true);
  const { _: i18n } = useLingui();

  const autoFocusFn = useCallback(
    (element: HTMLInputElement | null) => {
      if (element && email.length === 0) {
        element.focus();
      }
    },
    [email]
  );

  async function signInFormHandler(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setLoading(true);
    const success = await signIn(email, password);
    if (!success) setLoading(false);
  }

  return (
    <form onSubmit={signInFormHandler} className="flex flex-col gap-4">
      <Input
        id="email-input"
        type="email"
        placeholder={i18n(EMAIL_LABEL)}
        autoComplete="email"
        onChange={(e) => setEmail(e.target.value)}
        value={email}
        ref={autoFocusFn}
        className="rb-mask"
      />
      <Input
        id="password-input"
        type="password"
        placeholder={i18n(PASSWORD_LABEL)}
        autoComplete="current-password"
        onChange={(e) => setPassword(e.target.value)}
        autoFocus={email.length > 0}
      />
      <HStack className="w-full items-center justify-between">
        <NextLink
          href="/auth/create-account"
          className="text-sm text-foreground-secondary hover:underline"
        >
          {i18n(CREATE_ACCOUNT_LINK)}
        </NextLink>
        <NextLink
          href="/auth/forgot-password"
          className="text-sm text-foreground-secondary hover:underline"
        >
          {i18n(FORGOT_PASSWORD_LINK)}
        </NextLink>
      </HStack>
      <Button type="submit" size="full" variant="secondary" className="mt-4">
        {i18n(LOGIN_BUTTON)}
      </Button>
    </form>
  );
}
